import { Link, NavLink } from 'react-router-dom'
import { ShoppingBag } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useCartStore } from '@/lib/cart'

const nav = [
  { to: '/', label: 'Trang chủ' },
  { to: '/cua-hang', label: 'Cửa hàng' },
  { to: '/gioi-thieu', label: 'Giới thiệu' },
  { to: '/lien-he', label: 'Liên hệ' },
]

export default function SiteHeader() {
  const count = useCartStore((s) => s.getTotalItems())

  return (
    <header data-upbo-src="src/components/SiteHeader.tsx:17" className="sticky top-0 z-40 border-b border-[#e8d5d0] bg-[#fdf8f6]/85 backdrop-blur-xl">
      <div data-upbo-src="src/components/SiteHeader.tsx:18" className="mx-auto flex h-16 w-full max-w-6xl items-center gap-8 px-6">
        <Link to="/" className="text-lg font-semibold tracking-[-0.02em] text-[#7a4f45]">
          LumiSkin
        </Link>

        <nav data-upbo-src="src/components/SiteHeader.tsx:23" className="hidden items-center gap-1 sm:flex">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                cn(
                  'rounded-full px-4 py-1.5 text-sm transition-colors',
                  isActive
                    ? 'bg-[#f0dcd6] text-[#7a4f45]'
                    : 'text-[#9c7a72] hover:text-[#7a4f45]',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/gio-hang"
          aria-label="Giỏ hàng"
          className="ml-auto relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#e8d5d0] text-[#7a4f45] transition-colors hover:bg-[#f7ebe7]"
        >
          <ShoppingBag className="h-4 w-4" />
          {count > 0 && (
            <span data-upbo-src="src/components/SiteHeader.tsx:50" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#c98b7e] px-1 text-[11px] font-medium text-white">
              {count}
            </span>
          )}
        </Link>
      </div>
    </header>
  )
}
